module.exports = {
	"articleTitle1": "BTB, Charley's owners aim to lure 'townie' crowd with new venture",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Alley Bar",
	"articleLink1": "https://www.michigandaily.com/content/alley-bar-offer-patrons-sophistication-affordable-price",
	"articleLink2": "https://www.michigandaily.com/news/new-club-and-bar-open-downtown",
	"articleSnippet1": "Sep 15, 2010 ... Alley Bar — located on 112 West Liberty St. — has been a part of Ann Arbor's bar \nscene for more than 30 years, and has experienced various ...",
	"articleSnippet2": "Jan 10, 2012 ... With The Last Word, Lowenstein said the group wants to expand on the \nsuccessful bartending they've had at Alley Bar, one of their other local ...",
	"foodRecommendations": [
		{
			"text": "Pickle shots are allegedly amazing",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "BTB Cantina, Good Time Charley's owners to open downtown bar ...",
	"address": "112 W Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2798,
		"lng": -83.7493
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/alleybar.json
// module id = 806
// module chunks = 0